// Bildungsstätten-Karte (Templates/Location/List.html): Google Maps erst nach Klick
// auf "Karte laden" (Zwei-Klick-Lösung), Pins mit Info-Fenster und Cluster.
const CONSENT_KEY = 'bfw-google-maps-consent';
const CLUSTER_COLOR = '#005173';

function hasConsent() {
  try {
    return window.localStorage.getItem(CONSENT_KEY) === '1';
  } catch (e) {
    return false;
  }
}

function storeConsent() {
  try {
    window.localStorage.setItem(CONSENT_KEY, '1');
  } catch (e) {
    // Speicher blockiert: Zustimmung gilt nur für diesen Seitenaufruf
  }
}

function loadGoogleMaps(apiKey) {
  if (window.google?.maps?.importLibrary) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    window.__bfwMapsReady = resolve;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&v=weekly&callback=__bfwMapsReady`;
    script.async = true;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

function clusterRenderer({ count, position }) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">`
    + `<circle cx="24" cy="24" r="22" fill="${CLUSTER_COLOR}" stroke="white" stroke-width="2"/>`
    + `<text x="24" y="30" text-anchor="middle" font-family="Arial, sans-serif" font-size="16" font-weight="700" fill="white">${count}</text>`
    + `</svg>`;
  return new window.google.maps.Marker({
    position,
    icon: { url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`, scaledSize: new window.google.maps.Size(48, 48) },
    zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
  });
}

async function renderMap(container) {
  const canvas = container.querySelector('[data-location-map-canvas]');
  const consent = container.querySelector('[data-location-map-consent]');
  const { dataset } = container;

  await loadGoogleMaps(dataset.apiKey);
  const { Map, InfoWindow } = await window.google.maps.importLibrary('maps');
  await window.google.maps.importLibrary('marker');
  const { MarkerClusterer } = await import('@googlemaps/markerclusterer');

  if (!(canvas instanceof HTMLElement)) {
    throw new Error('location-map: canvas element not found');
  }
  consent.hidden = true;
  canvas.hidden = false;

  // Eigenes, frisch erzeugtes Element als Karten-Container (Google beobachtet es per IntersectionObserver)
  const mapElement = document.createElement('div');
  mapElement.className = 'h-full w-full';
  canvas.replaceChildren(mapElement);

  const map = new Map(mapElement, {
    center: { lat: 51.16, lng: 10.45 },
    zoom: 6,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
  });
  const infoWindow = new InfoWindow({ maxWidth: 380 });
  const pinIcon = {
    url: dataset.pinUrl,
    scaledSize: new window.google.maps.Size(38, 38),
    anchor: new window.google.maps.Point(19, 37),
  };
  const resultUids = (dataset.resultUids || '').split(',').filter(Boolean);
  const bounds = new window.google.maps.LatLngBounds();
  const resultBounds = new window.google.maps.LatLngBounds();

  const markers = [...container.querySelectorAll('template[data-location-marker]')].map((template) => {
    const position = { lat: parseFloat(template.dataset.lat), lng: parseFloat(template.dataset.lng) };
    const marker = new window.google.maps.Marker({ position, title: template.dataset.title, icon: pinIcon });
    marker.addListener('click', () => {
      infoWindow.setContent(template.content.cloneNode(true).firstElementChild);
      infoWindow.open({ map, anchor: marker });
    });
    bounds.extend(position);
    if (resultUids.includes(template.dataset.uid)) {
      resultBounds.extend(position);
    }
    return marker;
  });

  new MarkerClusterer({ map, markers, renderer: { render: clusterRenderer } });

  // Suche: auf Treffer + Suchort zoomen, sonst alle Bildungsstätten zeigen
  if (dataset.originLat && dataset.originLng && !resultBounds.isEmpty()) {
    resultBounds.extend({ lat: parseFloat(dataset.originLat), lng: parseFloat(dataset.originLng) });
    map.fitBounds(resultBounds, 60);
  } else if (!bounds.isEmpty()) {
    map.fitBounds(bounds, 40);
  }
}

export function initLocationMap() {
  const container = document.querySelector('[data-location-map]');
  if (!container) return;

  const start = () => renderMap(container).catch((error) => {
    console.error(error);
    const note = container.querySelector('[data-location-map-consent] p');
    if (note) note.textContent = 'Die Karte konnte nicht geladen werden.';
  });

  container.querySelector('[data-location-map-load]')?.addEventListener('click', () => {
    storeConsent();
    start();
  });

  if (hasConsent()) start();
}
